// @flow
import * as React from 'react';
import { find, first } from 'lodash/fp';
import { Route } from 'react-router-dom';

type TabScreenProps = {
    component: React.ComponentType<any>,
    name: string
};

const TabScreen = ({ path, component: Component, ...props }: TabScreenProps) => {
    // Return null because this function is statically analyzed and never rendered.
    return null;
};

type Props = {
    children: React.Node,
    history: { location: { search: string } },
    tabGroup: string
};

type State = {
    component: any,
    nextProps: {}
};

// Important - if the component that is using the TabSwitch is a connected component,
// then in the connected needs to be wrapped with withRouter from react-router-dom
// this is to stop the history props update from being blocked, see below article for more details:
// https://github.com/ReactTraining/react-router/blob/master/packages/react-router/docs/guides/blocked-updates.md

class TabSwitch extends React.Component<Props, State> {
    static Screen = TabScreen;

    state = {
        component: 'div',
        nextProps: {}
    };

    setUpComponent = ({ children, tabGroup, ...props }: Props) => {
        const qsVal = new URLSearchParams(props.history.location.search).get(tabGroup);
        const c = React.Children.toArray(children);
        const { props: { component, ...nextProps } } = find(x => x.props.name === qsVal, c) || first(c);

        this.setState({
            component,
            nextProps
        });
    };

    componentDidMount() {
        this.setUpComponent(this.props);
    }

    componentWillReceiveProps(nextProps: Props) {
        this.setUpComponent(nextProps);
    }

    render() {
        const { component: Component, nextProps: props } = this.state;
        return <Component {...props} />;
    }
}

class TabContentRouter extends React.Component<any, any> {
    static Screen = TabScreen;

    render() {
        return <Route render={({ history }) => <TabSwitch {...this.props} history={history} />} />;
    }
}

export default TabContentRouter;



// WEBPACK FOOTER //
// ./src/components/widgets/tabs-content/index.js